(function () {
  if (!window.HbElements) return;

  class HbModal extends HbElements.Component {
    onConnect() {
      this.modalId = this.dataset.modalId || '';
      this.overlay = this.querySelector('[data-modal-overlay]');
      this.dialog = this.querySelector('[data-modal-dialog]');
      this.lastFocus = null;
      this.opened = false;

      this.onKeydown = this.onKeydown.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.addEventListener('click', this.onCloseClick);
      if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);
      document.addEventListener('click', this.onDocumentClick);
    }

    onDisconnect() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('click', this.onCloseClick);
      if (this.overlay) this.overlay.removeEventListener('click', this.onOverlayClick);
      if (this.opened) this.unlockBody();
    }

    // Any link pointing at this modal's anchor is a trigger, so a plain
    // content-text with `#submit-a-tip` in its Link field opens the dialog.
    onDocumentClick(event) {
      if (!this.modalId) return;
      const trigger = event.target.closest(`a[href$="#${this.modalId}"]`);
      if (!trigger) return;
      if (this.contains(trigger)) return;
      event.preventDefault();
      this.open();
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      this.close();
    }

    onOverlayClick(event) {
      if (event.target !== this.overlay) return;
      this.close();
    }

    onCloseClick(event) {
      const close = event.target.closest('[data-modal-close]');
      if (!close || !this.contains(close)) return;
      event.preventDefault();
      this.close();
    }

    open() {
      if (this.opened) return;
      this.opened = true;
      this.lastFocus = document.activeElement;
      this.setAttribute('data-open', 'true');
      if (this.overlay) this.overlay.hidden = false;
      if (this.dialog) {
        this.dialog.setAttribute('aria-hidden', 'false');
        const focusTarget =
          this.dialog.querySelector('input:not([type="hidden"]), textarea') ||
          this.dialog.querySelector('[data-modal-close]') ||
          this.dialog;
        if (typeof window.trapFocus === 'function') {
          window.trapFocus(this.dialog, focusTarget);
        } else {
          focusTarget.focus();
        }
      }
      document.addEventListener('keydown', this.onKeydown);
      document.body.classList.add('overflow-hidden');
    }

    close() {
      if (!this.opened) return;
      this.opened = false;
      this.setAttribute('data-open', 'false');
      if (this.overlay) this.overlay.hidden = true;
      if (this.dialog) this.dialog.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', this.onKeydown);
      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(this.lastFocus);
      } else if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
      this.unlockBody();
    }

    unlockBody() {
      document.body.classList.remove('overflow-hidden');
    }
  }

  HbElements.define('hb-modal', HbModal);
})();
